import styles from './style.module.scss';
import { ReactNode } from 'react';

interface Props {
    title: string;
    icon: ReactNode;
    value: number;
    onClick: () => void;
};

/** A summary tile: how many jobs sit in one stage of the funnel. */
function InfoCard(props: Props) {
    const { title, icon, value, onClick } = props;

    return (
        <div className={styles.container} onClick={onClick}>
            <div className={styles.text}>
                <span className={styles.text_title}>{title}</span>
                <span className={styles.text_value}>{value}</span>
            </div>
            {icon}
        </div>
    );
};

export default InfoCard;
